<div class="admin-sidebar" *ngIf="isSidebarExpanded">
  <div *ngFor="let item of menuItems">
    <div
      *ngIf="!item.children?.length && item.visible"
      id="menu-items-without-children"
      class="menu-item"
      [routerLink]="item.route"
      routerLinkActive="active"
    >
      {{ item.label }}
    </div>

    <div
      id="menu-items-with-children-header"
      *ngIf="item.children && item.children.length > 0 && item.visible"
      class="menu-item expandable"
      (click)="item.expanded = !item.expanded"
    >
      {{ item.label }}
      <i
        class="pi"
        [ngClass]="{
          'pi-chevron-right': !item.expanded,
          'pi-chevron-down': item.expanded
        }"
      ></i>
    </div>
    <div
      *ngIf="
        item.expanded &&
        item.children &&
        item.children.length > 0 &&
        item.visible
      "
    >
      <div
        id="menu-items-with-children-items"
        *ngFor="let child of item.children"
        class="submenu-item"
        [routerLink]="child.route"
        routerLinkActive="active"
      >
        {{ child.label }}
      </div>
    </div>
  </div>
</div>
